import React from 'react';
export function Method() {
  return <section className="py-[60px] px-5 bg-brand-dark" data-id="element-185">
      <div className="max-w-[860px] mx-auto" data-id="element-186">
        <h2 className="text-[clamp(22px,4vw,36px)] font-black text-white mb-3 text-center" data-id="element-187">
          La Solución — El Método 4C
        </h2>
        <p className="text-base text-brand-gray text-center mb-10 max-w-[600px] mx-auto" data-id="element-188">
          4 pasos simples que funcionan con cualquier nivel de ingreso variable
        </p>

        <div className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-5 mt-10 sm:grid-cols-1" data-id="element-189">
          <div className="bg-brand-dark2 border border-brand-border rounded-2xl p-7 px-5 text-center transition-all duration-300 hover:-translate-y-1 hover:border-brand-red" data-id="element-190">
            <div className="text-4xl mb-3.5" data-id="element-191">✂️</div>
            <div className="text-[13px] font-black text-brand-red uppercase tracking-[2px] mb-2" data-id="element-192">
              C1 · CORTA
            </div>
            <h3 className="text-lg font-black text-white mb-2.5" data-id="element-193">
              Corta las Fugas
            </h3>
            <p className="text-[13px] text-brand-gray leading-[1.5]" data-id="element-194">
              Elimina las pérdidas invisibles que te roban $200+ al mes sin que
              te des cuenta
            </p>
          </div>

          <div className="bg-brand-dark2 border border-brand-border rounded-2xl p-7 px-5 text-center transition-all duration-300 hover:-translate-y-1 hover:border-brand-red" data-id="element-195">
            <div className="text-4xl mb-3.5" data-id="element-196">🏷️</div>
            <div className="text-[13px] font-black text-brand-red uppercase tracking-[2px] mb-2" data-id="element-197">
              C2 · CLASIFICA
            </div>
            <h3 className="text-lg font-black text-white mb-2.5" data-id="element-198">
              Clasifica las Deudas
            </h3>
            <p className="text-[13px] text-brand-gray leading-[1.5]" data-id="element-199">
              Ordena tus bills por urgencia real con el sistema ROJO · AMARILLO
              · VERDE
            </p>
          </div>

          <div className="bg-brand-dark2 border border-brand-border rounded-2xl p-7 px-5 text-center transition-all duration-300 hover:-translate-y-1 hover:border-brand-red" data-id="element-200">
            <div className="text-4xl mb-3.5" data-id="element-201">📅</div>
            <div className="text-[13px] font-black text-brand-red uppercase tracking-[2px] mb-2" data-id="element-202">
              C3 · CALENDARIZA
            </div>
            <h3 className="text-lg font-black text-white mb-2.5" data-id="element-203">
              Calendariza los Pagos
            </h3>
            <p className="text-[13px] text-brand-gray leading-[1.5]" data-id="element-204">
              Alinea cada pago con tu día de cobro — nunca más un late fee por
              desorden
            </p>
          </div>

          <div className="bg-brand-dark2 border border-brand-border rounded-2xl p-7 px-5 text-center transition-all duration-300 hover:-translate-y-1 hover:border-brand-red" data-id="element-205">
            <div className="text-4xl mb-3.5" data-id="element-206">📞</div>
            <div className="text-[13px] font-black text-brand-red uppercase tracking-[2px] mb-2" data-id="element-207">
              C4 · CIERRA
            </div>
            <h3 className="text-lg font-black text-white mb-2.5" data-id="element-208">
              Cierra Acuerdos
            </h3>
            <p className="text-[13px] text-brand-gray leading-[1.5]" data-id="element-209">
              Negocia con acreedores usando guiones probados — y gana la mayoría
              de las veces
            </p>
          </div>
        </div>
      </div>
    </section>;
}